import { render, staticRenderFns } from "./gHead.vue?vue&type=template&id=8de1dbc6&scoped=true&"
import script from "./gHead.vue?vue&type=script&lang=js&"
export * from "./gHead.vue?vue&type=script&lang=js&"
import style0 from "./gHead.vue?vue&type=style&index=0&id=8de1dbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de1dbc6",
  null
  
)

export default component.exports